<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
    <div class="float-right" v-if="consoleLogs.length" id="top">
      <b-pagination-nav v-model="currentPage" :link-gen="linkGen()" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
    </div>

    <h2 class="page-title">Console Logs</h2>
    <b-alert v-if="!scanStatus.completed" show variant="primary"><b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner> Check in progress.<br>
      Results will show up here automatically</b-alert>
    <b-alert v-if="scanStatus.completed && consoleLogs.length === 0" show variant="success"><span class="glyphicon glyphicon-thumbs-up" style="font-size:16px"></span> No Issues found.</b-alert>

    <b-row v-if="consoleLogs && consoleLogs.length">
      <b-col>
        <Widget
        >
          <div class="table-responsive">
          <table class="table table-hover" >
            <thead>
            <tr>
              <th scope="col">Log</th>
              <th scope="col">Pages</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="item in consoleLogs">

              <td width="95%" class="td-entry" >
                <div :class="`console-logs console-logs-${item.type}`">
                <i v-if="item.type === 'debug'" :class="`fa fa-wrench log-${item.type}`"  title="Debug"></i>
                <i v-if="item.type === 'warning'" :class="`fa fa-warning log-${item.type}`" title="Warning" ></i>
                <i v-if="item.type === 'log'" :class="`fa fa-info-circle log-${item.type}`" title="Log"></i>
                <i v-if="item.type === 'info'" :class="`fa fa-info-circle log-${item.type}`" title="Info"></i>
                <i v-if="item.type === 'error'" :class="`fa fa-times-circle log-${item.type}`" title="Error"></i>
                <pre ><code>{{item.text}}</code></pre>
                </div>
              </td>
              <td>
                <router-link :to="{ name: 'LogDetails', query: {id: item.id} }"><b><b-badge style="width:20px;padding: 0.4em 0.4em;" pill variant="secondary" :title="`Show pages.`"> {{item.pageCount}}</b-badge></b></router-link>
             </td>

            </tr>
            </tbody>
          </table>
          </div>
        </Widget>
        <div class="float-right">
          <b-pagination-nav v-model="currentPage" :link-gen="linkGen('#top')" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
        </div>
      </b-col>
    </b-row>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import DemoNotice from "@/components/DemoNotice/DemoNotice";

  import gql from "graphql-tag";
  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget, DemoNotice },
    apollo: {
      $subscribe: {
        websites_website: {
          query() {
            return gql`subscription {
                  websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                      websites_consolelogs(where: {active: {_eq: true}}, order_by: {id: asc}, limit: ${this.pageSize}, offset: ${(this.currentPage - 1) * this.pageSize || 0}){
                          id
                          text
                          type

                          websites_consolelog_pages_aggregate(where: {websites_crawledpage: {is_latest: {_eq: true}}}){
                            aggregate{
                                count
                            }
                          }
                        }

                        websites_consolelogs_aggregate(where: {active: {_eq: true}}){
                          aggregate{
                            count
                          }
                        }
                      }
          }`
          },
          skip () {
            return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
          },
          result (data) {
            this.loading = true;
            let pageCount = data.data.websites_website[0].websites_consolelogs_aggregate.aggregate.count;
            this.numberOfPages = Math.ceil(pageCount/this.pageSize);
            this.numberOfPages = Math.max(this.numberOfPages, 1);

            this.consoleLogs = [];

            if (data.data.websites_website && data.data.websites_website[0] && data.data.websites_website[0].websites_consolelogs) {
              for (let entry of data.data.websites_website[0].websites_consolelogs) {
                let consoleEntry = {
                  id: entry.id,
                  text: entry.text,
                  type: entry.type,
                  pageCount: entry.websites_consolelog_pages_aggregate.aggregate.count,
                  pages: [],
                };
                this.consoleLogs.push(consoleEntry)
              }
            }
            this.loading = false;
            this.dataLoaded = true;
          },

        },

      }
    },
    data() {
      return {
        pages: [],
        loading: true,
        dataLoaded: false,
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        consoleLogs: [],
        currentPage: 2,
        numberOfPages: 1,
        pageSize: 10,
        row_selected: false,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: "user"}),
    },
    watch: {
      'activeSite': function () {
        this.dataLoaded = false;
      }
    },
    methods: {
      linkGen(hash) {
        if (!hash){
          hash = '';
        }
        return (pageNum) =>{
          return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
        };
      },
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Console Logs - PageWatch.dev',
      // all titles will be injected into this template
    },
    created() {
      this.$watch("$route",() => {
        this.loading = true; this.currentPage = this.$route.query.page || 1;
        this.dataLoaded = false;
      }, {
        immediate: true
      });
    }
  };
</script>

<style src="./Javascript.scss" lang="scss" scoped />
<style lang="scss">
  div.console-logs {
    position:relative;
    margin-left:12px;
    i {
      position: absolute;
      top: 8px;
      left:-16px;
      font-size:11px;
      z-index:2;
      &.log-warning{
        color:orange;
      }
      &.log-error{
        color:red;
      }
      &.log-log{
        color:gray;
      }
      &.log-dropdown{
        position:relative;
        left:4px;
        top:-2px;
      }
    }
    pre {
      max-height: 100px;
      padding-left: 22px;
      position: relative;
    }
    &.console-logs-warning pre{
      background-color: #fffbe5;
      code{
        color: #5c3c00;
      }
    }
    &.console-logs-error pre{
      background-color:#fff0f0;
      code{
        color:red;
      }
    }
  }

  .console-text{
    /*font-family: "Lucida Grande", sans-serif;*/
    /*font-size:10pt;*/
  }
</style>
